import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import Select from 'react-select';
import { Link } from 'react-router-dom';
import { Tabs, Tab, Modal } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';


class SettingssEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      warning_points: 0,
      danger_points: 0,
      daily_points: 0,
      day_off_points: 0,
      primary_points: 0,
      fatigue_setting_primary_points: 0,
      fatigue_setting_warning_points: 0,
      fatigue_setting_danger_points: 0,
      fatigue_setting_daily_points: 0,
      fatigue_setting_day_off_points: 0,
      limit_extra_hours_week: 0,
      limit_extra_hours_month: 0,
      day_limit_extra_hours_week: 0,
      day_limit_extra_hours_month: 0,
      regular_hours: 0,
      minimum_day_off: 0,
      hour_points: 0,
      day_points: 0,
      rest_points: 0,
      day_off_points: 0,
      fatigue_setting_limit_extra_hours_week: 0,
      fatigue_setting_limit_extra_hours_month: 0,
      fatigue_setting_day_limit_extra_hours_week: 0,
      fatigue_setting_day_limit_extra_hours_month: 0,
      fatigue_setting_regular_hours: 0,
      fatigue_setting_minimum_day_off: 0,
      fatigue_setting_hour_points: 0,
      fatigue_setting_day_points: 0,
      fatigue_setting_rest_points: 0,
      fatigue_setting_day_off_points: 0,
      fatigue_setting_applicability_id: '',
      fatigue_setting_id: '',
      applicabilities: '',
      applicabilities_list: [],
      limits_task_list: [],
      tasks_list: [],
      fatigue_settings: {},
      applicability_tasks: {},
      modal: false,
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
    this.addTasks = this.addTasks.bind(this);
    this.add = this.add.bind(this);
    this.edit = this.edit.bind(this);
    this.showModal = this.showModal.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.deleteTask = this.deleteTask.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeMulti(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  showModal(event) {
    var self = this;
    var fatigue_setting_id = event.currentTarget.value;

    var data = self.state.fatigue_settings;
    data.map(function(dado, index){
      if (dado.id == fatigue_setting_id) {
        self.setState({
          fatigue_setting_primary_points: dado.primary_points,
          fatigue_setting_warning_points: dado.warning_points,
          fatigue_setting_danger_points: dado.danger_points,
          fatigue_setting_daily_points: dado.daily_points,
          fatigue_setting_day_off_points: dado.day_off_points,
          fatigue_setting_applicability_id: dado.applicability_id,
          fatigue_setting_limit_extra_hours_week: dado.limit_extra_hours_week,
          fatigue_setting_limit_extra_hours_month: dado.limit_extra_hours_month,
          fatigue_setting_day_limit_extra_hours_week: dado.day_limit_extra_hours_week,
          fatigue_setting_day_limit_extra_hours_month: dado.day_limit_extra_hours_month,
          fatigue_setting_regular_hours: dado.regular_hours,
          fatigue_setting_minimum_day_off: dado.minimum_day_off,
          fatigue_setting_hour_points: dado.hour_points,
          fatigue_setting_day_points: dado.day_points,
          fatigue_setting_rest_points: dado.rest_points,          
          fatigue_setting_id: dado.id,
          applicability_tasks: dado.applicability_tasks,
          modal: true,
        });
      }
    });
  }
  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/configuracoes/fadiga';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
        if (responseJson.status === 'success') {
          self.setState({
            fatigue_settings: responseJson.data.fatigue_settings,
            applicabilities_list: responseJson.data.applicabilities,
            tasks_list: responseJson.data.tasks_list,
            limits_task_list: responseJson.data.limits_task_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  // Fetch salvando a adição de task
  addTasks(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      applicability_id: this.state.fatigue_setting_applicability_id,
      task_id: this.state.task_id,
      limit_task: this.state.limit_task,
      text: this.state.text,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aplicabilidade/tarefas/restricao' , { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({
            fatigue_settings: responseJson.data,
          });
          var data = responseJson.data;
          data.map(function(dado, index){
            if (dado.id == self.state.fatigue_setting_id) {
              self.setState({
                fatigue_setting_primary_points: dado.primary_points,
                fatigue_setting_warning_points: dado.warning_points,
                fatigue_setting_danger_points: dado.danger_points,
                fatigue_setting_daily_points: dado.daily_points,
                fatigue_setting_day_off_points: dado.day_off_points,
                fatigue_setting_applicability_id: dado.applicability_id,
                fatigue_setting_limit_extra_hours_week: dado.limit_extra_hours_week,
                fatigue_setting_limit_extra_hours_month: dado.limit_extra_hours_month,
                fatigue_setting_day_limit_extra_hours_week: dado.day_limit_extra_hours_week,
                fatigue_setting_day_limit_extra_hours_month: dado.day_limit_extra_hours_month,
                fatigue_setting_regular_hours: dado.regular_hours,
                fatigue_setting_minimum_day_off: dado.minimum_day_off,
                fatigue_setting_hour_points: dado.hour_points,
                fatigue_setting_day_points: dado.day_points,
                fatigue_setting_rest_points: dado.rest_points,          
                fatigue_setting_id: dado.id,
                applicability_tasks: dado.applicability_tasks,
                modal: true,
              });
            }
          });
        }
        
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  // Fetch salvando a adição
  add(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      warning_points: this.state.warning_points,
      danger_points: this.state.danger_points,
      daily_points: this.state.daily_points,
      day_off_points: this.state.day_off_points,
      primary_points: this.state.primary_points,
      applicabilities: this.state.applicabilities,
      limit_extra_hours_week: this.state.limit_extra_hours_week,
      limit_extra_hours_month: this.state.limit_extra_hours_month,
      day_limit_extra_hours_week: this.state.day_limit_extra_hours_week,
      day_limit_extra_hours_month: this.state.day_limit_extra_hours_month,
      regular_hours: this.state.regular_hours,
      minimum_day_off: this.state.minimum_day_off,
      hour_points: this.state.hour_points,
      day_points: this.state.day_points,
      rest_points: this.state.rest_points,   
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/configuracoes/fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({
            fatigue_settings: responseJson.data,
          });
        }
        
      }).catch((error) => {
        console.error(error);
      });
    });
  }
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.fatigue_setting_id,
      warning_points: this.state.fatigue_setting_warning_points,
      danger_points: this.state.fatigue_setting_danger_points,
      daily_points: this.state.fatigue_setting_daily_points,
      day_off_points: this.state.fatigue_setting_day_off_points,
      primary_points: this.state.fatigue_setting_primary_points,
      applicability_id: this.state.fatigue_setting_applicability_id,
      limit_extra_hours_week: this.state.fatigue_setting_limit_extra_hours_week,
      limit_extra_hours_month: this.state.fatigue_setting_limit_extra_hours_month,
      day_limit_extra_hours_week: this.state.fatigue_setting_day_limit_extra_hours_week,
      day_limit_extra_hours_month: this.state.fatigue_setting_day_limit_extra_hours_month,
      regular_hours: this.state.fatigue_setting_regular_hours,
      minimum_day_off: this.state.fatigue_setting_minimum_day_off,
      hour_points: this.state.fatigue_setting_hour_points,
      day_points: this.state.fatigue_setting_day_points,
      rest_points: this.state.fatigue_setting_rest_points,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/configuracoes/fadiga', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({
            fatigue_settings: responseJson.data,
          });
        }
        
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  delete (event) {
    var fatigue_setting_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Configuracoes.EditarConfiguracoes.deletarConfiguracao);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/configuracoes/fadiga/' + fatigue_setting_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(fatigue_setting_id);
            self.loadData();
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deleteRow(fatigue_setting_id) {
    var data = this.state.fatigue_settings;
    data.map(function(dado, index){
      if (dado.id == fatigue_setting_id) {
        data.splice(index, 1);
      }
    });
    this.setState({fatigue_settings: data});
  }

  deleteTask (event) {
    var applicability_task_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Configuracoes.EditarConfiguracoes.deletarTarefa);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/tarefa/restricao/' + applicability_task_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_settings: responseJson.data,
            });
            var data = responseJson.data;
            data.map(function(dado, index){
              if (dado.id == self.state.fatigue_setting_id) {
                self.setState({
                  fatigue_setting_primary_points: dado.primary_points,
                  fatigue_setting_warning_points: dado.warning_points,
                  fatigue_setting_danger_points: dado.danger_points,
                  fatigue_setting_daily_points: dado.daily_points,
                  fatigue_setting_day_off_points: dado.day_off_points,
                  fatigue_setting_applicability_id: dado.applicability_id,
                  fatigue_setting_limit_extra_hours_week: dado.limit_extra_hours_week,
                  fatigue_setting_limit_extra_hours_month: dado.limit_extra_hours_month,
                  fatigue_setting_day_limit_extra_hours_week: dado.day_limit_extra_hours_week,
                  fatigue_setting_day_limit_extra_hours_month: dado.day_limit_extra_hours_month,
                  fatigue_setting_regular_hours: dado.regular_hours,
                  fatigue_setting_minimum_day_off: dado.minimum_day_off,
                  fatigue_setting_hour_points: dado.hour_points,
                  fatigue_setting_day_points: dado.day_points,
                  fatigue_setting_rest_points: dado.rest_points,          
                  fatigue_setting_id: dado.id,
                  applicability_tasks: dado.applicability_tasks,
                  modal: true,
                });
              }
            });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Configuracoes.EditarConfiguracoes.titulo}</h3>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}> 
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicabilities"
                value={this.state.applicabilities}
                searchable={true}
                placeholder={this.locale.Configuracoes.EditarConfiguracoes.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeMulti.bind(this, 'applicabilities')}
                options={this.state.applicabilities_list}
                multi={true}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaAzul}:</label>
              <input type="number" name="primary_points" className="form-control" placeholder="" value={this.state.primary_points} onChange={this.handleChange.bind(this, 'primary_points')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaAmarela}:</label>
              <input type="number" name="warning_points" className="form-control" placeholder="" value={this.state.warning_points} onChange={this.handleChange.bind(this, 'warning_points')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaVermelha}:</label>
              <input type="number" name="danger_points" className="form-control" placeholder="" value={this.state.danger_points} onChange={this.handleChange.bind(this, 'danger_points')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosDiario}:</label>
              <input type="number" name="daily_points" className="form-control" placeholder="" value={this.state.daily_points} onChange={this.handleChange.bind(this, 'daily_points')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Configuracoes.EditarConfiguracoes.formulario.PontuacaoPorDiaDeFolga}:</label>
              <input type="number" name="day_off_points" className="form-control" placeholder="" value={this.state.day_off_points} onChange={this.handleChange.bind(this, 'day_off_points')} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
          </div>
        </div>
      </form>
      <hr/>
      <h4>{this.locale.Configuracoes.EditarConfiguracoes.tituloConfiguracoesDePontuacao}</h4>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.Configuracoes.EditarConfiguracoes.tabelaConfiguracoesDePontuacao.TipoDeColaborador}
            </th>
            <th>{this.locale.Configuracoes.EditarConfiguracoes.tabelaConfiguracoesDePontuacao.Acoes}</th>
          </tr>
        </thead>
        <tbody id="configuracoes">
          {Object.keys(self.state.fatigue_settings).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.fatigue_settings[k].id}
                </td>
                <td>
                  {self.state.fatigue_settings[k].name}
                </td>
                <td>
                  <button className="btn btn-primary btn-sm" value={self.state.fatigue_settings[k].id} onClick={self.showModal}>
                    <i className="fa fa-fw fa-pencil"></i>
                  </button>
                  <button className="btn btn-sm btn-danger" value={self.state.fatigue_settings[k].id} onClick={self.delete}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Modal show={this.state.modal} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
        <Modal.Header>
          <h4 className="pull-left">{this.locale.Configuracoes.EditarConfiguracoes.tituloEditarConfiguracao}</h4>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
          <div className="clearfix"></div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.edit}> 
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.AplicabilidadeTipoDeColaborador}:</label>
                  <Select
                    className="form-field-name"
                    name="fatigue_setting_applicability_id"
                    value={this.state.fatigue_setting_applicability_id}
                    searchable={true}
                    placeholder={this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChange.bind(this, 'fatigue_setting_applicability_id')}
                    options={this.state.applicabilities_list}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaAzul}:</label>
                  <input type="number" name="fatigue_setting_primary_points" className="form-control" placeholder="" value={this.state.fatigue_setting_primary_points} onChange={this.handleChange.bind(this, 'fatigue_setting_primary_points')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaAmarela}:</label>
                  <input type="number" name="fatigue_setting_warning_points" className="form-control" placeholder="" value={this.state.fatigue_setting_warning_points} onChange={this.handleChange.bind(this, 'fatigue_setting_warning_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaVermelha}:</label>
                  <input type="number" name="fatigue_setting_danger_points" className="form-control" placeholder="" value={this.state.fatigue_setting_danger_points} onChange={this.handleChange.bind(this, 'fatigue_setting_danger_points')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosDiario}:</label>
                  <input type="number" name="fatigue_setting_daily_points" className="form-control" placeholder="" value={this.state.fatigue_setting_daily_points} onChange={this.handleChange.bind(this, 'fatigue_setting_daily_points')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.PontuacaoPorDiaDeFolga}:</label>
                  <input type="number" name="fatigue_setting_day_off_points" className="form-control" placeholder="" value={this.state.fatigue_setting_day_off_points} onChange={this.handleChange.bind(this, 'fatigue_setting_day_off_points')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
              </div>
            </div>
          </form>
          <hr/>
          <h4>{this.locale.Configuracoes.EditarConfiguracoes.tituloTarefasDeRestricao}</h4>
          <form onSubmit={this.addTasks}> 
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.Tarefa}:</label>
                  <Select
                    className="form-field-name"
                    name="task_id"
                    value={this.state.task_id}
                    searchable={true}
                    placeholder={this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.SelecionarAplicabilidade}
                    onChange={this.handleSelectChangeMulti.bind(this, 'task_id')}
                    options={this.state.tasks_list}
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.LimiteDaRestricao}:</label>
                  <Select
                    className="form-field-name"
                    name="limit_task"
                    value={this.state.limit_task}
                    searchable={true}
                    placeholder={this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.SelecionarLimite}
                    onChange={this.handleSelectChangeMulti.bind(this, 'limit_task')}
                    options={this.state.limits_task_list}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.Restricao}:</label>
                  <input type="text" name="text" className="form-control" placeholder={this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.Restricao} value={this.state.text} onChange={this.handleChange.bind(this, 'text')} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.botaoCadastrarTarefa}</button>
              </div>
            </div>
          </form>
      <hr/>
      <h4>{this.locale.Configuracoes.EditarConfiguracoes.tituloTarefasDaAplicabilidade}</h4>
      <table className="table">
        <thead>
          <tr>
            <th>
              #
            </th>
            <th>
              {this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Limite}
            </th>
            <th>
              {this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Tarefa}
            </th>
            <th>
              {this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Restricao}
            </th>
            <th>{this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Acoes}</th>
          </tr>
        </thead>
        <tbody id="tasks">
          {Object.keys(self.state.applicability_tasks).map(function(k) {
            return (
              <tr>
                <td>
                  {self.state.applicability_tasks[k].id}
                </td>
                <td>
                  {self.state.applicability_tasks[k].limit_label}
                </td>
                <td>
                  {self.state.applicability_tasks[k].task_label}
                </td>
                <td>
                  {self.state.applicability_tasks[k].limit_restriction}
                </td>
                <td>
                  <button className="btn btn-sm btn-danger" value={self.state.applicability_tasks[k].id} onClick={self.deleteTask}>
                    <i className="fa fa-fw fa-trash"></i>
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
          <i className="fa fa-fw fa-close"></i></button>
        </Modal.Footer>
      </Modal>
    </div>
  </div>
</div>
    );
  }
}

export default SettingssEdit;



// WEBPACK FOOTER //
// ./src/Components/Settings/SettingsEdit.js